<template>
  <div class="app-main__inner">
    <breadcrumb />
    <div class="row">
      <div class="col-md-6 col-xl-4">
        <div class="card mb-3 widget-content bg-midnight-bloom" @click="changeOption('dstv')">
          <div class="widget-content-wrapper text-white">
            <div class="widget-content-left">
              <div class="widget-heading">Select option</div>
            </div>
            <div class="widget-content-right">
              <div class="widget-numbers text-white"><span>DSTV</span></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-xl-4">
        <div class="card mb-3 widget-content bg-arielle-smile" @click="changeOption('startimes')">
          <div class="widget-content-wrapper text-white">
            <div class="widget-content-left">
              <div class="widget-heading">Select option</div>
            </div>
            <div class="widget-content-right">
              <div class="widget-numbers text-white"><span>Startimes</span></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-xl-4">
        <div class="card mb-3 widget-content bg-grow-early" @click="changeOption('gotv')">
          <div class="widget-content-wrapper text-white">
            <div class="widget-content-left">
              <div class="widget-heading">Select option</div>
            </div>
            <div class="widget-content-right">
              <div class="widget-numbers text-white"><span>GOTV</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <dstv-component v-if="visible == 'dstv'"/>
    <startimes-component v-if="visible == 'startimes'"/>
    <gotv-component v-if="visible == 'gotv'"/>
  </div>
</template>
<script>
/* eslint-disable no-undef */
// import AuthenticationService from "@/services/AuthenticationService";
import Breadcrumb from "@/components/_partials/Breadcrumb";
import DstvComponent from "./DSTV";
import StartimesComponent from "./Startimes";
import GotvComponent from "./GoTV";
export default {
  name: "TV",
  metaInfo: {
    // all titles will be injected into this template
    titleTemplate: "%s | TV",
    meta: [
      {
        name: "description",
        content: "We are coming soon",
      },
      {
        name: "keywords",
        content: "We will fix this soon",
      },
    ],
  },
  components: {
    Breadcrumb,
    DstvComponent,
    StartimesComponent,
    GotvComponent
  },
  data() {
    return {
      visible: 'dstv'
    };
  },
  methods: {
    changeOption (value) {
      this.visible = value
    }
  },
};
</script>
<style scoped>
.card.mb-3 {
  cursor: pointer;
}
</style>
